import { RadioButton } from "@/Common/Components/Inputs/RadioButton";
import { ElementType, ValidationType } from "@/Common/Models/Forms/FormTemplateInterfaces";
import { QuestionnaireAnswer } from "@/Common/Models/Questionnaires/QuestionnaireAnswer";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { ElementRenderer } from "./ElementRenderer";

class YesNoElementRenderer extends ElementRenderer {
    public get elementType(): ElementType {
        return ElementType.YesNoOptionInput;
    }

    public get propertyName(): string {
        return "selectedOption";
    }

    public isValid(): boolean {
        const validationRules = this.component.ValidationRules ?? [];
        return this.answers.any()
            && validationRules.some(x => x.ValidationType === ValidationType.NotEmpty);
    }

    public renderAnswer(onChange?: (answer: QuestionnaireAnswer) => void, disabled: boolean = false): JSX.Element {
        const options: KeyValuePair<string, string>[] = [
            new KeyValuePair(cacheStore.GetString("YesLabel"), "yes"),
            new KeyValuePair(cacheStore.GetString("NoLabel"), "no")
        ];

        const checkedRadioBtn = this.answers.firstOrDefault();

        return (
            <div key={this.component.InternalName} style={{ maxWidth: "200px" }}>
                <RadioButton
                    mainDivCSS=""
                    selectedItem={checkedRadioBtn?.Value}
                    radioInputGroupId={`radio_group_${this.component.FormPath.toString()}`}
                    items={Immutable.List(options)}
                    onChange={item => this.handleOnChange(item.Value, checkedRadioBtn, onChange)}
                    disabled={disabled}
                />
            </div>
        );
    }

    private handleOnChange(value: string, answer: QuestionnaireAnswer, onChange?: (answer: QuestionnaireAnswer) => void): void {
        const selected = answer
            ? answer
            : {
                PropertyType: ElementType.YesNoOptionInput,
                PropertyPath: this.component.FormPath.toString()
            };

        const newAnswer = new QuestionnaireAnswer(selected);
        newAnswer.Value = value;
        newAnswer.PropertyName = this.propertyName;

        onChange && onChange(newAnswer);
    }
}

export { YesNoElementRenderer };
